<h2 mat-dialog-title>Attach Document</h2>
<h3 mat-dialog-title>Number :- {{ data.name }}</h3>
<form [formGroup]="attachForm" class="form-container">
    <mat-dialog-content>
        <!-- Invoice Upload -->
        <div class="file-upload">
            <mat-form-field appearance="outline" class="small-field">
                <mat-label>Value</mat-label>

                <span matPrefix style="margin:0 3px !important;">{{ data.currency }}</span>
                <input matInput formControlName="InvoiceValue" required  (keypress)="allowOnlyNumbers($event, attachForm.get('InvoiceValue'))" />
            </mat-form-field>
        </div>

        <div class="file-upload">
            <label>Invoice</label>
            <div class="upload-wrapper">
                <button mat-raised-button color="primary" type="button" (click)="invoiceFileInput.click()">
                    <mat-icon>upload_file</mat-icon> Choose File
                </button>
                <span class="file-name">{{ invoiceFileName || 'No file chosen' }}</span>
                <input #invoiceFileInput type="file" (change)="onFileChange($event, 'Invoice')" hidden />
            </div>
        </div>
        <div class="file-upload">
            <label>Delivery Note / Completion Certificate</label>
            <div class="upload-wrapper">
                <button mat-raised-button color="primary" type="button" (click)="deliveryNoteFileInput.click()">
                    <mat-icon>upload_file</mat-icon> Choose File
                </button>
                <span class="file-name">{{ deliveryNoteFileName || 'No file chosen' }}</span>
                <input #deliveryNoteFileInput type="file" (change)="onFileChange($event, 'DeliveryNote')" hidden />
            </div>
        </div>
        <!-- Delivery Note Upload -->
        <!-- <div class="file-section">
        <label class="file-label">Invoice</label>
        <input type="file" (change)="onInvoiceSelected($event)" />
        <div *ngIf="invoiceFile" class="file-preview">
            📄 {{ invoiceFile.name }}
        </div>
    </div>

  
    <div class="file-section">
        <label class="file-label">Delivery Note</label>
        <input type="file" (change)="onDeliveryNoteSelected($event)" />
        <div *ngIf="deliveryNoteFile" class="file-preview">
            📄 {{ deliveryNoteFile.name }}
        </div>
    </div> -->
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <!-- <button mat-button (click)="onCancel()">Cancel</button> -->
        <!-- <button mat-raised-button color="primary" (click)="onUpload()" [disabled]="!invoiceFile && !deliveryNoteFile">
        Upload
    </button> -->
        <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" type="submit" (click)="onUpload()">Upload</button>
        </div>
    </mat-dialog-actions>
</form>